import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/utils/store';
import routes from './routes';

Vue.use(VueRouter);

const router = new VueRouter({
  scrollBehavior: () => ({ x: 0, y: 0 }),
  routes,

  mode: process.env.VUE_ROUTER_MODE,
  base: process.env.VUE_ROUTER_BASE,
});

router.beforeEach((to, from, next) => {
  if (
    to.matched.some((record) => record.meta.requiresAuth)
    && to.matched.some((record) => record.meta.requiresOrganization)
  ) {
    if (store.getGetters('auth', 'isLoggedIn') && store.getGetters('organization', 'hasOrganization')) {
      next();
      return;
    }
    next('/login');
  }
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getGetters('auth', 'isLoggedIn')) {
      next();
      return;
    }
    next({ path: '/login' });
  } else {
    next();
  }
});

export default router;
